<template>
  <div class="grow">
    <DialogOverlay :text="$t('stranger.endtext')" :show="showEndMessage" @onOk="showEndMessage = false"></DialogOverlay>
    <div class="st-window">
      <div class="header">
        <span class="text">{{ $t('stranger.talkiewalkie.title') }}</span>
        <div class="close-button">
          <button class="st-button" @click="close()">X</button>
        </div>
      </div>
      <div class="content ">
        <div class="st-tw-container">
         <img class="st-tw-bg" src="/stranger/assets/images/ST_TALKIE_BG.png" />
         <img class="st-tw-button st-b-top st-b-left" v-if="!active" @click="button(0, 1)" src="/stranger/assets/images/ST_TALKIE_BTN_UP.png" />
         <img class="st-tw-button st-b-top st-b-right" v-if="!active" @click="button(1, 1)" src="/stranger/assets/images/ST_TALKIE_BTN_UP.png" />
         <img class="st-tw-button st-b-bottom st-b-left" v-if="!active" @click="button(0, -1)" src="/stranger/assets/images/ST_TALKIE_BTN_DOWN.png" />
         <img class="st-tw-button st-b-bottom st-b-right" v-if="!active" @click="button(1, -1)" src="/stranger/assets/images/ST_TALKIE_BTN_DOWN.png" />        
         <img class="st-tw-led" v-if="active" src="/stranger/assets/images/ST_TALKIE_ON.png" />
         <img class="st-tw-led" v-if="!active" src="/stranger/assets/images/ST_TALKIE_OFF.png" />
         <div class="st-tw-subtitle" v-if="subtitle !== ''">{{ $t('stranger.talkiewalkie.' + subtitle) }}</div>
         <div class="st-tw-channel st-c-left ">{{ leftChannel | twodigits }}</div>
         <div class="st-tw-channel st-c-right">{{ rightChannel | twodigits }}</div>        
         <div v-if="active && showList">
             <select v-model="listSelection" class="st-select st-tw-answer">
               <option v-for="entry in getList(currentStep)" :key="entry.name" :value="entry">
                {{ entry.name }}
              </option>
            </select> 
            <button class="st-button st-tw-answer-ok" @click="submit()">{{ $t('common.buttons.ok') }}</button>
          </div>           
        </div> 
      </div>
    </div>
    <Sound src="/stranger/assets/audio/click.mp3" ref="clickSound" />
    <Sound src="/stranger/assets/audio/talkie_morse.mp3" volume="0.5" ref="morseSound" />    
    <Sound src="/stranger/assets/audio/radio_static.mp3" volume="0.5" loop ref="staticSound" />
    <Sound :src="`/stranger/assets/audio/${currentLocale}/talkie_start.mp3`" volume="1.0" ref="startSound" />
    <Sound :src="`/stranger/assets/audio/${currentLocale}/talkie_danger.mp3`" volume="1.0" ref="dangerSound" />
    <Sound :src="`/stranger/assets/audio/${currentLocale}/talkie_win.mp3`" volume="1.0" ref="winSound" />
    <Sound :src="`/stranger/assets/audio/${currentLocale}/talkie_roger_2.mp3`" volume="1.0" ref="rogerSound" />
    <Sound :src="`/stranger/assets/audio/${currentLocale}/talkie_wrong.mp3`" volume="1.0" ref="wrongSound" />       
    <Sound src="/stranger/assets/audio/synthwave_win.mp3" volume="1.0" loop ref="winMusic" />   
  </div>
</template>
  
<script>
  import currentGameMixin from "@/mixins/currentGameMixin";
  import DialogOverlay from "@/components/DialogOverlay";  
  import Sound from "@/components/stranger/Sound";  

  export default {
    name: "TalkieWalkie",

    components: {
      DialogOverlay,
      Sound
    },

    mixins: [currentGameMixin],

    data: () => ({
      leftChannel: 0,
      rightChannel: 0,
      listSelection: '',
      currentStep: 0,
      active: false,
      showList: false,
      subtitle: '',
      solved: false,
      showEndMessage: false,
    }),

    methods: {
      close() {
        this.$router.push({ name: 'stranger-home' });
      },
      clickSound() {
        this.$refs.clickSound.stop();
        this.$refs.clickSound.play();
      },
      playWithTimeout(soundRef, withMorse, callback) {
        const morseDurationInMs = this.$strangerStore.talkiewalkie.soundDurations['morse'] * 1000;
        const durationInMs = this.$strangerStore.talkiewalkie.soundDurations[soundRef.replace('Sound', '')] * 1000;

        if (withMorse) {
          this.$refs.morseSound.play();
          setTimeout(() => {
            this.$refs.morseSound.stop();
            this.$refs[soundRef].play();        
            setTimeout(() => {
              this.$refs[soundRef].stop();
              callback();
            }, durationInMs);
          }, morseDurationInMs);          
        } else {
          this.$refs.morseSound.stop();
          this.$refs[soundRef].play();        
          setTimeout(() => {
            this.$refs[soundRef].stop();
            callback();
          }, durationInMs);
        }
      },
      button(b, inc) {
        if (b === 0) {
          this.leftChannel += inc;
          
          if(this.leftChannel < 0) this.leftChannel = 19;
          if(this.leftChannel > 19) this.leftChannel = 0;          
        } else {
          this.rightChannel += inc;
          
          if(this.rightChannel < 0) this.rightChannel = 19;
          if(this.rightChannel > 19) this.rightChannel = 0;           
        }

        this.$strangerStore.talkiewalkie.currentChannel = [this.leftChannel, this.rightChannel];
        this.$strangerStore.saveState();

        this.clickSound();
        this.refreshChannel();
      },
      refreshChannel() {
        if (this.leftChannel === this.$strangerStore.talkiewalkie.correctChannel[0]-1 && 
            this.rightChannel === this.$strangerStore.talkiewalkie.correctChannel[1]-1) {
          this.$refs.staticSound.stop();
          this.currentStep = this.$strangerStore.talkiewalkie.currentStep;
          this.active = true;
          this.showList = false;

          if (this.currentStep == 0) {
            if (!this.solved) {
              this.playWithTimeout('startSound', false, () => {
                this.showList = true;
              });
            }
          } else {
            this.showList = true;
          }
        } else {
          this.$refs.staticSound.play();          
          this.active = false;
          this.showList = false;
        }
      },
      getList() {
        return this.$strangerStore.talkiewalkie.choices[this.currentStep];
      },
      submit() {
        const list = this.$strangerStore.talkiewalkie.choices[this.currentStep];
        const choice = list.find(c => c.name === this.listSelection.name);
        if (choice) {
          switch(choice.outcome) {
            case 'win':
              this.showList = false;
              this.playWithTimeout('winSound', true, () => {
                this.win();
              });
              break;
            case 'wrong':
              this.showList = false;
              this.playWithTimeout('wrongSound', true, () => {
                this.showList = true;
              });
              break;
            case 'danger':
              this.showList = false;
              this.playWithTimeout('dangerSound', true, () => {
                this.showList = true;
              });
              break;
            case 'roger':
              this.showList = false;
              this.playWithTimeout('rogerSound', true, () => {
                this.showList = true;
                this.currentStep++;
                //this.$strangerStore.talkiewalkie.currentStep = this.currentStep;
                //this.$strangerStore.saveState();
              });
              break;
          }


          setTimeout(() => {
            this.subtitle = choice.outcome
            setTimeout(() => {
              this.subtitle = ''
            }, (this.$strangerStore.talkiewalkie.soundDurations[choice.outcome] - 1) * 1000)
          }, 3000)

        }
      },
      win() {
        this.$refs.startSound.stop();
        this.$refs.winMusic.play();
        this.solved = true;
        this.showEndMessage = true;
        this.$strangerStore.solved = true;
        this.$strangerStore.saveState();
      }
    },

    watch: { },

    computed: { },

    async mounted() { 
      this.leftChannel = this.$strangerStore.talkiewalkie.currentChannel[0];
      this.rightChannel = this.$strangerStore.talkiewalkie.currentChannel[1]; 
      this.currentStep = this.$strangerStore.talkiewalkie.currentStep;
      this.solved = this.$strangerStore.solved;

      if (this.solved) this.win();

      this.refreshChannel();
    }
  };
</script>

<style lang="scss" scoped>
  @import '@/assets/css/stranger.scss';

  .st-window {
    .content {
      max-height: 550px;
      overflow-y: auto;

      .st-tw-container {
        margin: auto;
        width: 150px;
        position: relative;

        img.st-tw-bg {
          max-width: 150px;
          margin-top: 8px;
        }

        img.st-tw-button {
          max-width: 35px;
          position: absolute;
          top: 287px;

          border-bottom: 4px solid #000;     
          cursor: pointer; 
          touch-action: manipulation;

          &.st-b-top { top: 287px; }
          &.st-b-bottom { top: 360px; }
          &.st-b-left { left: 32px; }
          &.st-b-right { left: 83px; }

          &.st-b-top:active {
            top: 289px;
            border-bottom: 2px solid #000;
          }

          &.st-b-bottom:active {
            top: 362px;
            border-bottom: 2px solid #000;
          }          
        }

        img.st-tw-led {
          max-width: 94px;
          position: absolute;
          top: 255px;
          left: 29px; 
        }

        .st-tw-answer {
          max-width: 200px;
          width:100px;
          position: absolute;
          top: 375px;
          left: 25px; 
        }

        .st-tw-answer-ok {
          max-width: 100px;
          width: 100px;
          position: absolute;
          top: 425px;
          left: 25px; 
        }

        div.st-tw-subtitle {
          max-width: 250px;
          position: absolute;
          top: 157px;
          left: -50px;
          color: #000;
          width: 250px;
          background-color: #000;
          font-family: Amiga4ever;
          font-size: 14px;
          color: $light-color;
        }

        div.st-tw-channel {
          max-width: 10px;
          position: absolute;
          top: 327px;
          left: 38px; 
          color: #000;
          font-family: Amiga4ever;    
          font-size: 14px; 
          
          &.st-c-right {
            left: 88px;
          }
        }
      }
    }
  }
</style>
  